import script from "./BreadcrumbLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./BreadcrumbLink.vue?vue&type=script&setup=true&lang=ts"

import "./BreadcrumbLink.vue?vue&type=style&index=0&id=51dbf3b7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51dbf3b7"]])

export default __exports__